import type { UseInfiniteQueryResult } from '@tanstack/react-query';
import { useEffect } from 'react';

interface UseAutoFetchAllPagesParams {
  query: Pick<UseInfiniteQueryResult, 'fetchNextPage' | 'hasNextPage' | 'isFetchingNextPage' | 'isFetchNextPageError'>;
  loadedCount: number;
  enabled?: boolean;
}

// `loadedCount` re-runs the effect after every page: when a page resolves before React renders its fetching state,
// `hasNextPage` and `isFetchingNextPage` look unchanged and loading would stall. A failed page leaves `hasNextPage`
// true, so it stops there rather than re-requesting the page in a loop.
export function useAutoFetchAllPages({ query, loadedCount, enabled = true }: UseAutoFetchAllPagesParams) {
  const { fetchNextPage, hasNextPage, isFetchingNextPage, isFetchNextPageError } = query;

  useEffect(() => {
    if (!enabled || !hasNextPage || isFetchingNextPage || isFetchNextPageError) {
      return;
    }

    fetchNextPage();
  }, [enabled, hasNextPage, isFetchingNextPage, isFetchNextPageError, fetchNextPage, loadedCount]);
}
